<template>
  <div>
    <el-dialog
      top="6vh"
      width="380px"
      center
      :title="`${faceVideoImportObj.bankCardNumber} 扫脸视频汇入`"
      :visible="faceVideoImportObj.visible"
      @close="HandleCancel()"
    >
      <el-select
        @change="getAccVideo()"
        filterable
        v-model="fromAccId"
        placeholder="选择从哪张银行卡汇入"
        size="small"
        style="width: 100%"
      >
        <el-option
          v-for="option in bankOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
          :disabled="option.disabled"
        >
        </el-option>
      </el-select>

      <div v-if="hasFaceVideo">
        <div class="has-video-title">已获取下列扫脸视频</div>
        <div v-for="(item, index) in dataList" :key="item.type">
          <el-link
            v-if="item.url"
            type="primary"
            @click="HandlePreview(index)"
            class="video-description"
          >
            <i class="el-icon-video-camera" /> {{ item.description }}
          </el-link>
        </div>

        <div class="has-video-subtitle">
          注意：从其它银行卡复制的视频将会覆盖此卡已上传过的视频。<br /><br />
          确定是否复制视频至以下银行卡？
        </div>
        <div class="target-card-title">
          {{ faceVideoImportObj.bankCardNumber }} ({{
            faceVideoImportObj.bankName
          }})
        </div>
      </div>

      <div v-else class="empty-video-title">来源无任何视频</div>

      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel()"> 取消 </el-button>
        <el-button
          :disabled="!hasFaceVideo"
          :loading="submitLoading"
          round
          type="primary"
          @click="HandleSubmit()"
        >
          确定汇入
        </el-button>
      </span>
    </el-dialog>

    <FaceVideoPreviewerDialog
      :face-video-previewer-dialog-obj.sync="faceVideoPreviewerDialogObj"
    />
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import FaceVideoPreviewerDialog from "./FaceVideoPreviewerDialog";
import { copyAccVideo, userAllAccount, getAccVideo } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: {
    faceVideoImportObj: {
      type: Object,
    },
  },
  components: {
    FaceVideoPreviewerDialog,
  },
  data() {
    return {
      submitLoading: false,
      fromAccId: null,
      bankOptions: [],
      dataList: [],
      hasFaceVideo: false,
      faceVideoPreviewerDialogObj: {},
    };
  },
  watch: {
    faceVideoImportObj(row) {
      if (row.visible) {
        this.getUserAllAccount();
      }
    },
  },
  methods: {
    HandlePreview(index) {
      this.faceVideoPreviewerDialogObj = {
        dataList: this.dataList,
        index,
        visible: true,
      };
    },
    getAccVideo() {
      getAccVideo(this.fromAccId).then((res) => {
        this.dataList = res.data;
        this.hasFaceVideo = this.dataList.find((item) => item.url !== "");
      });
    },
    getUserAllAccount() {
      userAllAccount(this.faceVideoImportObj.userId).then((res) => {
        this.bankOptions = res.data.map((res) => {
          return {
            label: `${res.bankCardNumber} (${res.bankName})`,
            value: res.id,
            disabled: this.faceVideoImportObj.id === res.id ? true : false,
          };
        });
      });
    },
    HandleSubmit() {
      if (!this.hasFaceVideo) {
        return this.$notify.error("来源无任何视频");
      }
      this.$confirm(
        `确定要将所有视频汇入到银行卡「${this.faceVideoImportObj.bankCardNumber}」吗？`,
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          this.submitLoading = true;
          copyAccVideo({
            fromAccId: this.fromAccId,
            toAccId: this.faceVideoImportObj.id,
          })
            .then((res) => {
              this.$notify.success(res.message);
              this.HandleCancel();
              this.$emit("HandleGetList");
            })
            .finally(() => {
              this.submitLoading = false;
            });
        })
        .catch(() => {});
    },
    HandleCancel() {
      this.dataList = [];
      this.hasFaceVideo = false;
      this.fromAccId = null;
      this.$emit("update:face-video-import-obj", {});
    },
  },
};
</script>

<style lang="scss" scoped>
video {
  transform: rotate(270deg);
}
#preview-dialog /deep/ {
  .el-dialog {
    background-color: transparent;
    box-shadow: none;
  }
  .el-dialog__title {
    color: #fff;
    text-shadow: 0px 0px 6px #000000c4;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.backdrop-blur {
  backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.6);
}

.target-card-title {
  color: #e6a23c;
  font-weight: 500;
}
.has-video-title {
  color: #67c23a;
  font-weight: 500;
  padding: 20px 0;
}
.has-video-subtitle {
  color: #ff0000;
  font-weight: 500;
  padding: 20px 0;
}
.empty-video-title {
  color: #ff0000;
  font-weight: 500;
  padding: 20px 0;
}
.video-description {
  cursor: pointer;
  font-size: 13px;
  margin-bottom: 5px;
}
.video-empty {
  color: #ccc;
  text-align: center;
  border: 1px solid #eee;
  margin: 8px 0;
  width: 150px;
  height: 195px;
  border-radius: 3px;
  line-height: 195px;
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/FaceVideoImportDialog.vue